(ns bp-libs.design-system.components.buttons
  "Namespace for buttons"
  (:require [bp-libs.js-loader.core :as js-loader]
            [cljs.core.async :refer-macros [go]]
            [cljs.core.async.interop :refer-macros [<p!]]))

(defn Button
  "A simple default button styled"
  {:storybook {:on-click      {:action "OnClick Button"}
               :extra-classes {:name         "Extra Classes"
                               :defaultValue nil
                               :control      {:type "text"}}
               :id            {:name         "Text"
                               :type         {:name "string" :required false}
                               :defaultValue "an-id"
                               :control      {:type "text"}}
               :text          {:name         "Text"
                               :type         {:name "string" :required true}
                               :defaultValue "My Text"
                               :control      {:type "text"}}
               :color         {:name         "Color"
                               :defaultValue "white"
                               :options      ["white" "green" "yellow"]
                               :control      {:type "select"}}}}
  [{:keys [on-click on-key-down extra-classes color rounded-full? tab-index disabled? react-ref]} children]
  (let [button-color   (condp = color
                         "green"  "bg-green-300 hover:bg-green-500 focus:ring-green-400"
                         "yellow" "bg-yellow-300 hover:bg-yellow-500 focus:ring-yellow-400"
                         "gray"   "bg-gray-600 text-white hover:text-gray-600 hover:bg-white focus:ring-gray-200 focus:bg-white focus:text-gray-600"
                         "black"  "bg-gray-900 text-white hover:text-gray-900 hover:bg-white focus:ring-gray-200 focus:bg-white focus:text-gray-900"
                         "transparent" "bg-transparent hover:bg-white focus:bg-white focus:text-gray-900 hover:text-gray-900 text-gray-400"
                         "bg-white hover:bg-gray-50 focus:ring-white hover:text-gray-900 text-black")
        default-styles "transition-colors duration-200 ease-in-out relative focus:ring-2 font-medium p-2.5 inline-flex items-center"]
    [:button {:type        "button"
              :ref         react-ref
              :tab-index   tab-index
              :disabled    disabled?
              :class       (apply merge [default-styles button-color (if rounded-full? "rounded-full" "rounded-lg")] extra-classes)
              :on-click    on-click
              :on-key-down on-key-down}
     children]))

(defn google-sso
  {:storybook {:shape          {:name         "Shape"
                                :defaultValue "rectangular"
                                :options      ["rectangular" "pill" "circle" "square"]
                                :control      {:type "select"}}
               :text           {:name         "Text"
                                :defaultValue "signup_with"
                                :options      ["signup_with" "signup_up" "continue_with" "signin"]
                                :control      {:type "select"}}
               :theme          {:name         "Theme"
                                :defaultValue "outline"
                                :options      ["outline" "filled_blue" "filled_black"]
                                :control      {:type "select"}}
               :size           {:name         "Size"
                                :defaultValue "large"
                                :options      ["small" "medium" "large"]
                                :control      {:type "select"}}
               :client-id      {:name         "Client ID"
                                :defaultValue ""
                                :control      {:type "text"}}}}
  [{:keys [on-load-complete mount-component] :as props}]
  ;; Loads Google GSI
  (go
    (<p! (js-loader/load-scripts {#(exists? js/google)
                                  "https://accounts.google.com/gsi/client"}))
    (on-load-complete))
  ;; Renders the component
  [mount-component (-> props
                       (update :id    #(or % "google-signin-button"))
                       (update :shape #(or % "rectangular"))
                       (update :text  #(or % "signup_with"))
                       (update :theme #(or % "outline"))
                       (update :size  #(or % "large")))])
